import { CloverIcon } from './CloverIcon';

/**
 * author: Michael Richins
 * id 0B70716D-3C56-43F1-85D4-B264C05DCC32
 * name clover
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clover.svg
 * tags
 * - Nature 
 */
export const LuckIcon = CloverIcon;
export default LuckIcon